import type { UIEvent, ReactNode } from 'react';

export enum CREDIT_CARD_CONST {
  TEST_ID = 'credit-card',
}

export type CreditCardConfig = {
  deliveryDate: string;
  description?: string;
  expirationDate: string;
  icon?: ReactNode;
  iconColor?: string;
  linkButton?: string;
  onClick?: (event: UIEvent<HTMLButtonElement>) => void;
  trackUserClicks: (event: UIEvent<HTMLButtonElement>) => void;
  orderCode: string;
  paymentMethod: string;
  size?: string;
  status?: string;
  title: string;
  titleButton?: string;
  value: string;
  variant?: string;
};

export type CreditCardProps = CreditCardConfig;
